<template>
  <div class="commandSystemWrap mainPageBg">
    <div class="header"
      id="svgContent">
      <SvgTitle :key="svgKey"
        svgId="svgSmartEnergy"
        svgUrl="@/assets/images/msgt/homeTitle.svg" />
    </div>
    <div class="content">
      <div class="leftBox">
        <CommandUserCard />
        <CommandUserList />
      </div>
      <div class="middleBox">
        <div class="tolBox">
          <div class="row"
            v-for="(v,i) in tolData"
            :key="i">
            <p>{{v.name}}</p>
            <h5 :style="{color:v.color}">{{v.value}}</h5>
          </div>
        </div>
        <div class="mapView">
          <MapCharts :id="'commandSystemWrap'" />
        </div>
        <div class="listBox">
          <CommandAreaList />
        </div>
      </div>
      <div class="rightBox">
        <CommandCard v-for="(v,i) in rightDataList"
          :key="i"
          :itemObj="v" />
      </div>
    </div>

  </div>
</template>

<script>
import MapCharts from "@/components/msgt/MapCharts";
import CommandCard from "@/components/msgt/CommandCard";
import CommandAreaList from "@/components/msgt/CommandAreaList";
import CommandUserCard from "@/components/msgt/CommandUserCard";
import CommandUserList from "@/components/msgt/CommandUserList";
import SvgTitle from "@/components/Svg/SvgTitle";

export default {
  components: {
    MapCharts,
    CommandCard,
    CommandAreaList,
    CommandUserCard,
    CommandUserList,
    SvgTitle,
  },
  data() {
    return {
      mapData: {},
      svgKey: 1,
      rightDataList: [
        {
          title: "今日能耗",
          dataArr: [
            { name: "用电", value: 3233, unit: "kw·h", scale: "+1.4%" },
            {
              name: "用水",
              value: 223,
              unit: "m³",
              scale: "-2.5%",
            },
            {
              name: "用气",
              value: 151,
              unit: "m³",
              scale: "+1.5%",
            },
          ],
        },
        {
          title: "光伏发电",
          dataArr: [
            { name: "今日", value: 3312, unit: "kw·h", scale: "+12%" },
            { name: "本月", value: 19272, unit: "kw·h", scale: "-45.6%" },
            {
              name: "本年",
              value: 72433,
              unit: "kw·h",
              scale: "+12.5%",
            },
          ],
        },
        {
          title: "EIOT",
          dataArr: [
            { name: "正常", value: 7726, scale: "+1.2%" },
            { name: "离线", value: 149, scale: "+2.2%" },
            { name: "报警", value: 329, scale: "-6.2%" },
          ],
        },
        {
          title: "报警统计",
          dataArr: [
            { name: "今日", value: 191, scale: "-13%" },
            { name: "本月", value: 5542, scale: "+7%" },
            { name: "本年", value: 11208, scale: "-4%" },
          ],
        },
      ],
      tolData: [
        { name: "已建设", value: 11, color: "#A2E1FF" },
        { name: "建设中", value: 7, color: "#39E4EA" },
        { name: "待建设", value: 3, color: "#F4C602" },
      ],
    };
  },
  methods: {},
  created() {},
};
</script>

<style lang="scss" scoped>
.commandSystemWrap {
  background: #050b1f;
  .header {
    width: 100%;
    height: 80px;
  }
  .content {
    width: 100%;
    height: calc(100% - 80px);
    @include setFlexBetween;
    background: url("~@/assets/images/msgt/backgroud.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .leftBox {
      width: 28%;
      height: 100%;
    }
    .middleBox {
      width: 49%;
      height: 100%;
      @include setFlexCenter;
      // justify-content: space-between;
      position: relative;
      .tolBox {
        width: 100%;
        height: 15%;
        position: absolute;
        top: 0;
        @include setFlexCenter;
        .row {
          width: 30%;
          @include setFlexCenter;
          align-items: baseline;
          p {
            color: #a1afba;
            font-size: 18px;
          }
          h5 {
            margin-left: 10px;
            font-size: 30px;
          }
        }
      }
      .mapView {
        width: 100%;
        height: 90%;
      }
      .listBox {
        width: 100%;
        height: 17%;
        position: absolute;
        bottom: 0;
      }
    }
    .rightBox {
      width: 22%;
      height: 98%;
      @include setFlexColumn;
      justify-content: space-between;
    }
  }
}
</style>